"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIssueTypeEntity = exports.TypeDisplayWithHydration = void 0;
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../state/redux/hooks");
var _issueTypes = require("../../state/redux/ducks/issueTypes");
var _TypeDisplay = require("./TypeDisplay");
var _useTypeCategory = require("./useTypeCategory");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useIssueTypeEntity = typeId => {
  const issueTypeEntitiesMap = (0, _hooks.useSelector)(_issueTypes.getIssueTypeEntitiesMap);
  if (!typeId) {
    return undefined;
  }
  return issueTypeEntitiesMap[typeId];
};
exports.useIssueTypeEntity = useIssueTypeEntity;
const TypeDisplayWithHydration = _ref => {
  let {
    status,
    typeId,
    typeCategoryId
  } = _ref;
  const issueType = useIssueTypeEntity(typeId);
  const issueTypeCategory = (0, _useTypeCategory.useTypeCategory)({
    typeId,
    typeCategoryId
  });
  if (issueType && issueTypeCategory && issueType.title && issueTypeCategory.title) {
    return /*#__PURE__*/_react.default.createElement(_TypeDisplay.TypeDisplay, {
      status: status,
      stampCode: issueType.code,
      title: "".concat(issueTypeCategory.title, " > ").concat(issueType.title)
    });
  }
  return null;
};
exports.TypeDisplayWithHydration = TypeDisplayWithHydration;
//# sourceMappingURL=TypeDisplayWithHydration.js.map